import { BasicTag } from "types/TagType";
import find from "lodash/find";
import { genreLink, moodLink, tagLink } from "constants/ExploreLinks";
import { cdnUrl } from "lib/imageTools";
import { TagSerializersBasicTag } from "types/serializers";

// Genres with a cover image
const genresWithCover = [
  "adventure",
  "classics",
  "dystopian",
  "fantasy",
  "fiction",
  "history",
  "lgbtq",
  "mystery",
  "nonfiction",
  "science-fiction",
  "war",
  "young-adult",
];
export const headerPath = "/static/bookHeaders";
const defaultHeader = `${headerPath}/bookstore.webp`;

export const GenresOptions = [
  { value: "adventure", label: "Adventure" },
  { value: "classics", label: "Classics" },
  { value: "dystopian", label: "Dystopian" },
  { value: "fantasy", label: "Fantasy" },
  { value: "fiction", label: "Fiction" },
  { value: "history", label: "History" },
  { value: "lgbtq", label: "LGBTQ" },
  { value: "mystery", label: "Mystery" },
  { value: "nonfiction", label: "Nonfiction" },
  { value: "science-fiction", label: "Science Fiction" },
  { value: "war", label: "War" },
  { value: "young-adult", label: "Young Adult" },
]

export function findHeaderImageForGenres(
  tags: BasicTag[] | TagSerializersBasicTag[],
  unknownHeader = defaultHeader
) {
  const genreSlugs = (tags || []).map((basicTag) => basicTag.tagSlug);

  if (genreSlugs.length === 0) {
    return cdnUrl(unknownHeader);
  }
  const headerGenre = find(
    genreSlugs,
    (genreSlug) => genresWithCover.indexOf(genreSlug) !== -1
  );

  return cdnUrl(
    headerGenre ? `${headerPath}/${headerGenre}.webp` : unknownHeader
  );
}
export function findHeaderForGenres(
  tags: BasicTag[] | TagSerializersBasicTag[] ,
  unknownHeader = defaultHeader
) {
  return findHeaderImageForGenres(tags, unknownHeader);
}

export function headerForGenre(genre: string) {
  return cdnUrl(`${headerPath}/${genre}.webp`);
}

export function tagIconFor(category: string) {
  if (category === "genre") {
    return genreLink.iconDuo;
  }
  if (category === "mood") {
    return moodLink.iconDuo;
  }
  return tagLink.iconDuo;
}
